import { render, staticRenderFns } from "./data-train.vue?vue&type=template&id=19bc591e"
import script from "./data-train.vue?vue&type=script&lang=ts"
export * from "./data-train.vue?vue&type=script&lang=ts"
import style0 from "./data-train.vue?vue&type=style&index=0&id=19bc591e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports